import React, { useRef } from 'react';
import { useJotformEmbeds } from '../hooks/useJotformEmbeds';

/**
 * Renders sanitized post HTML and loads Jotform forms via iframe after mount.
 */
export function JotformEmbedContent({ html, className, as: Tag = 'div', ...rest }) {
  const containerRef = useRef(null);
  useJotformEmbeds(containerRef, html);

  if (!html) return null;

  return <Tag ref={containerRef} className={className} {...rest} />;
}

export default JotformEmbedContent;
